import {create} from 'zustand';
import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import * as Sentry from '@sentry/react';
import {devtools} from 'zustand/middleware';
import {immer} from 'zustand/middleware/immer';

interface FingerprintState {
    fingerprintRequestId?: string;
    isLoading: boolean;
    requested: boolean;
    getFingerprintData: () => Promise<void>;
}

export const useFingerprintStore = create(
    devtools(
        immer<FingerprintState>((set, get) => ({
            fingerprintRequestId: undefined,
            isLoading: false,
            requested: false,

            getFingerprintData: async () => {
                if (
                    get().requested ||
                    import.meta.env.NODE_ENV === 'development'
                ) {
                    return;
                }

                try {
                    set({isLoading: true});

                    const fpPromise = await FingerprintJS.load({
                        apiKey: 'PnOoLT4a489VopKYnjCl',
                        endpoint: [
                            'https://ident.amnistreasury.com/Y5Zc3TlLSDZaFwHl/5R1GQW0juXtzYU1e?region=eu',
                            FingerprintJS.defaultEndpoint,
                        ],
                        scriptUrlPattern: [
                            'https://ident.amnistreasury.com/Y5Zc3TlLSDZaFwHl/pEnhJk0DQkdMg4Pk?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>',
                            FingerprintJS.defaultScriptUrlPattern,
                        ],
                        region: 'eu',
                    });

                    const fingerprintData = await fpPromise.get();
                    set({
                        fingerprintRequestId: fingerprintData.requestId,
                        requested: true,
                    });
                } catch (error) {
                    Sentry.captureException(error);
                } finally {
                    set({isLoading: false});
                }
            },
        })),
    ),
);
